import { api } from '../../../index';
import { GetOnboardingGoals } from '../../types/useOnboarding.types';

export const getOnboardingGoals = async (planLabelsIds: string[], mainSegment: string): Promise<GetOnboardingGoals> => {
  return await api.get<GetOnboardingGoals>('/onboarding/goals/anonymous', { planLabelsIds, mainSegment });
};
